import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface ValidationRuleCount extends AttributesMixin<typeof ValidationRuleCount> { }

@define
export class ValidationRuleCount extends Model {
  static endpoint = restfulIO('api/v1/ingest/validation-rules/count');

  static attributes = {
    count: Number
  }

  parse(number: Number) {
    return { count: number }
  }
}
